import { CancelToken } from 'axios';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../store';
import { getOptionsSupplier, selectOptionsSupplier, selectOptionsSupplierState } from '../../../store/entities/optionsSupplier';
import { FetchState } from '../../../store/fetchState';
import { getLangNameObj } from '../../../utils/format';
import { QcsAutocompleteWithoutFormik } from '../form/QcsAutocompleteWithoutFormik';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';

interface Props {
  value?: ReferenceDto[];
  onChange: (value?: ReferenceDto) => void;
}

export const GridFilterSupplierMultiple: FC<Props> = ({ value = [], onChange }) => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const optionsSupplier = useAppSelector(selectOptionsSupplier);
  const optionsSupplierState = useAppSelector(selectOptionsSupplierState);

  const loadOptions = (search: string | undefined, cancelToken: CancelToken) => {
    dispatch(getOptionsSupplier(search, cancelToken));
  };

  const handleChange = (value?: ReferenceDto | ReferenceDto[] | null) => {
    onChange((value as ReferenceDto) ?? undefined);
  };

  return (
    <QcsAutocompleteWithoutFormik
      multiple={true}
      options={optionsSupplier}
      loading={optionsSupplierState === FetchState.Loading}
      loadingError={optionsSupplierState === FetchState.Error}
      loadOptions={loadOptions}
      value={value}
      getOptionId={(option: ReferenceDto) => option.id!}
      getOptionName={(option: ReferenceDto) => getLangNameObj(i18n, option)}
      onChange={handleChange}
    />
  );
};
